export default __webpack_public_path__ + "static/media/copy_active.c202550e.svg";